import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Platform } from '@ionic/angular/lazy';
import { Router } from '@angular/router';
import { LangProvider } from './services/lang/lang';
import { SpiaggiaService } from './services/utils/spiaggia.service';
import { AuthGuardService } from './services/auth-guard.service';
import { FcmService } from './services/fcm.service';
import { HttprequestService } from './services/httprequest.service';
import { StorageService } from './services/storage-service.service';
import { serviziRest } from 'src/environments/environment';
import { AlertService } from './services/alert-service.service';
import { UserService } from './services/utils/user.service';
import { SplashService } from './services/splash.service';
import { STRIPE_KEY } from '../environments/environment';
import { Stripe } from '@capacitor-community/stripe';
import { register } from 'swiper/element/bundle';
import { firstValueFrom } from 'rxjs';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  isServerStatusDown: boolean = false;
  tokenValue: boolean = false; //qui verifico il token dell'utente: se ok, manda ai servizi altrimenti alla login
  platformOs: string = "";
  private versionListenerRegistered = false;
  private splash = inject(SplashService);


  constructor(
    private router: Router,
    private platform: Platform,
    private lingua: LangProvider,
    public myService: SpiaggiaService,
    private userService: UserService,
    private httpService: HttprequestService,
    public alertService: AlertService,
    private fcmService: FcmService,
    private storage: StorageService,
    private authGuardService: AuthGuardService,
  ) {
    this.splash.mostra();
    this.checkServerStatus();
  }

  async checkServerStatus() {
    this.isServerStatusDown = false;
    await this.platform.ready();

    // Controllo versione obsoleta: all'avvio + a ogni resume, a livello app (copre kill/reopen e minimize su qualsiasi pagina)
    this.registerVersionChecks();

    try {
      const res = await firstValueFrom(
        this.httpService.doGetTimeout(serviziRest.checkAppInManutenzione)
      );

      this.splash.nascondi();

      if (res != null && res != undefined) {
        if (res == 1) {
          this.myService.appInManutenzione = true;
          this.isServerStatusDown = true;
          this.alertService.alertAppInManutenzione();
        } else {
          this.myService.appInManutenzione = false;
          this.isServerStatusDown = false;
          this.initializeApp();
        }
      }
    } catch (error) {
      console.log(error);
      this.splash.nascondi();
    }
  }


  initializeApp() {
    this.checkFirstSteps();
    this.fcmService.initPush();
    this.fcmService.resetBadgeCount();
    this.initializeStripe();
  }

  // Registra (una volta sola) il controllo versione all'avvio e a ogni ritorno in foreground
  private registerVersionChecks() {
    this.checkAppVersion(); // cold start
    if (!this.versionListenerRegistered) {
      this.versionListenerRegistered = true;
      App.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
          this.checkAppVersion(); // resume: minimize/kill → riapri
        }
      });
    }
  }

  // Fail-open: blocca solo su risposta esplicita "obsoleta"; su errore/ambiguo NON modifica lo stato
  // (una versione già confermata obsoleta resta bloccata anche se un check successivo fallisce)
  checkAppVersion() {
    this.userService.checkAppPlatform();
    const postData = {
      version: this.userService.versionNr,
      platform: this.userService.platformOs
    };

    if (postData.version !== '' && postData.platform !== '') {
      this.httpService.doPostApplicationJson(serviziRest.checkAppVersion, postData)
        .subscribe({
          next: (data: any) => {
            if (data?.result === false) {
              this.myService.isVersionObsoleta = true;
            } else if (data?.result === true) {
              this.myService.isVersionObsoleta = false;
            }
            // risposta ambigua → invariato (fail-open)
          },
          error: (error) => {
            console.error('Errore nel controllo versione app:', error);
            // fail-open: non modifico isVersionObsoleta
          }
        });
    }
  }

  async openAppStore(): Promise<void> {
    const url = this.myService.isPlatformAndroid
      ? 'https://play.google.com/store/apps/details?id=com.nastydevops.sunsetapp'
      : 'https://apps.apple.com/app/id1464731875';
    await Browser.open({ url });
  }


  async initializeStripe(): Promise<void> {
    Stripe.initialize({
      publishableKey: STRIPE_KEY,
    });
  }


  checkFirstSteps() {
    this.storage.get('locale_lang').then((res => {
      if (res != undefined && res != null && res != '') {
        this.lingua.languageSelected = res;
      }
      else {
        this.storage.set('locale_lang', 'IT');
        this.lingua.languageSelected = 'IT';
      }

      this.userService.checkAppPlatform();
      this.checkLastStepsAndStart();
      this.checkFunzioniDisponibili();
    }));
  }

  checkFunzioniDisponibili() {
    this.myService.checkSocialLogin();
    this.myService.getLimiteOrarioPrenotazione();
  }

  checkLastStepsAndStart() {


    this.storage.get('token').then((res => {
      if (res != undefined && res != null && res != '') {
        this.userService.isUserLoggedIn = true;
        this.storage.get('username').then((res => {
          this.userService.getDatiUtente(res, '');
        }));
        this.myService.checkPopOver();
        // this.router.navigate(['/mainpage']);
        this.authGuardService.canActivate();
      }
      else {
        this.userService.isUserLoggedIn = false;
        this.router.navigate(['/welcome']);
        this.authGuardService.canActivate();
      }
    }));
  }


  logout() {

    this.userService.isUserLoggedIn = false;
    this.storage.set('token', '');
    this.storage.set('tutorialCompleted', '');
    this.storage.set('tokenPush', '');
    this.storage.set('username', '');
    this.storage.set('showModale', '');
    this.storage.set('showModaleGenerica', '');
    this.storage.set('dataCookieGenerico', '');
    this.router.navigate(['/welcome']);
  }

}
